module.exports = __webpack_public_path__ + "static/media/anchor_rank_3.cf4e68bc.png";